<template>
    <div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'impersonate-user',
    data() {
        return {
            currentSession: null,

        };
    },
    mounted() {
        this.setCurrentSession();
    },
    methods: {
        setCurrentSession: async function () {
            this.currentSession = localStorage.getItem(
                "vue-authenticate.vueauth_access_token"
            );

            if (!this.currentSession) {
                this.$store.dispatch('getRandomString', 20).then(async (res) => {
                    this.currentSession = res;

                    await localStorage.setItem(
                        'vue-authenticate.vueauth_access_token',
                        this.currentSession
                    );

                    this.$store.commit('isAuthenticated', {
                        isAuthenticated:true,
                    });
                   
                    this.startImpersonate();
                });

            } else
                this.startImpersonate();
        },
       decode: function(str) {

            let txt = document.createElement("textarea");

            txt.innerHTML = str;

            return txt.value;

        },   
        startImpersonate: async function () {

            this.$store.commit("SET_CURRENT_ID", this.id);
            this.loading = true;
            await axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + "/conference/ibba2022/impersonate",
                    {},
                    {
                        params: {
                            session_id: this.currentSession,
                            user_id: this.$route.params.id
                        },
                    }
                )
                .then((res) => {
                    if (res.hasOwnProperty("data") && res.data.error) {
                        this.$store.commit("SET_ERROR_BIT", true);
                        this.$store.commit(
                            "SET_ERROR_INFO",
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode +
                            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/conference/ibba2022/impersonate" <br>`
                        );
                        throw new Error(
                            "<br>" +
                            "Server responded with error = True <br> errorCode: " +
                            res.data.errorCode
                        );
                    }
                    if(this.$route.query.url && res.data.error == false){
                        let url = `${process.env.VUE_APP_BASE_URL}/${this.decode(this.$route.query.url)}`; 
                        window.location.replace(url);
                    }
                    else if(res.data.error == false) {
                        this.$router.push({ name: res.data.defaultScreen == "" ? 'Search' : res.data.defaultScreen });
                    }
                    
                });
        },
    }
};
</script>
